import { getChains } from '@wagmi/core';

import { wagmiConfig } from '@pkg/providers';

export function getChainFromChainId(chainId: number) {
    const chains = getChains(wagmiConfig);
    return chains.find((chain) => chain.id === chainId)?.name;
}
export function getWalletWithPrefix(account: string, chainId?: number) {
    const currencyPrefix = chainId ? getChainFromChainId(chainId)?.toLowerCase() : 'aptos';
    return `${currencyPrefix}.${account}`;
}
